import Tabs from "./functional";
export default Tabs;
